import React from "react";
import {
    FaCircle, FaServer, FaClock, FaExclamationTriangle, FaCheckCircle
} from "react-icons/fa";
import "./service-health-card.css";

function ServiceHealthCard({ service }) {
    const statusConfig = {
        ACTIVE: { color: '#22c55e', bg: 'rgba(34,197,94,0.1)', icon: FaCheckCircle, label: 'Activo' },
        DEGRADED: { color: '#f59e0b', bg: 'rgba(245,158,11,0.1)', icon: FaExclamationTriangle, label: 'Degradado' },
        INACTIVE: { color: '#ef4444', bg: 'rgba(239,68,68,0.1)', icon: FaExclamationTriangle, label: 'Inactivo' },
    };

    const cfg = statusConfig[service.status] || statusConfig.INACTIVE;
    const StatusIcon = cfg.icon;

    const formatTime = (minutes) => {
        if (minutes < 1) return 'Hace un momento';
        if (minutes < 60) return `Hace ${minutes}m`;
        const h = Math.floor(minutes / 60);
        const m = minutes % 60;
        return `Hace ${h}h ${m > 0 ? `${m}m` : ''}`;
    };

    const errorRateColor = service.errorRateLast5min > 30
        ? '#ef4444'
        : service.errorRateLast5min > 10
            ? '#f59e0b'
            : '#22c55e';

    return (
        <div className="shc-card" style={{ '--status-color': cfg.color }}>
            <div className="shc-header">
                <div className="shc-name-wrap">
                    <FaServer className="shc-server-icon" />
                    <span className="shc-name" title={service.serviceName}>
                        {service.serviceName}
                    </span>
                </div>
                <div className="shc-status-badge" style={{ background: cfg.bg, color: cfg.color }}>
                    <StatusIcon />
                    <span>{cfg.label}</span>
                </div>
            </div>

            <div className="shc-metrics">
                <div className="shc-metric">
                    <span className="shc-metric-label">
                        <FaClock /> Último evento
                    </span>
                    <span className="shc-metric-value">
                        {formatTime(service.minutesSinceLastActivity)}
                    </span>
                </div>
                <div className="shc-metric">
                    <span className="shc-metric-label">Eventos / 5min</span>
                    <span className="shc-metric-value">{service.eventsLast5min}</span>
                </div>
                <div className="shc-metric">
                    <span className="shc-metric-label">Tasa de error</span>
                    <span className="shc-metric-value" style={{ color: errorRateColor }}>
                        {service.errorRateLast5min?.toFixed(1)}%
                    </span>
                </div>
            </div>

            {/* Visual error-rate bar. */}
            <div className="shc-error-bar-wrap">
                <div
                    className="shc-error-bar"
                    style={{
                        width: `${Math.min(100, service.errorRateLast5min)}%`,
                        background: errorRateColor
                    }}
                />
            </div>

            {/* Corner health indicator. */}
            <div className="shc-pulse" style={{ '--pulse-color': cfg.color }}>
                <FaCircle style={{ color: cfg.color, fontSize: 8 }} />
            </div>
        </div>
    );
}

export default ServiceHealthCard;
